var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SidebarHeader"},[_c('IconLabel',{staticClass:"SidebarHeader__iconLabel",attrs:{"icon":_vm.icon,"title":_vm.title,"text":"","variant":"red"}}),_c('button',{staticClass:"SidebarHeader__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('iconic',{attrs:{"name":"xIcon"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }